module.exports = __webpack_public_path__ + "media/euro-petrol-video.c91daef4.mp4";